import React from 'react';
import Tabs from '../card-table/tabs';
import cn from 'classnames';
import { Button } from '@material-ui/core';
import {
  ColumnTotalStakedAmountTitle,
  ColumnStatusTitle,
  ColumnEstimatedAprTitle,
  ColumnEstimatedDailyRewardsTitle,
  ColumnEarnedRewardsTitle,
} from '../../../components/Stake/column';
import * as modalActions from '../../../actions/modal-actions';
import Stub from '../card-table/items/stub';
import {
  DOT,
  FXF,
  KSM,
  KYL,
  L3P,
  LABS,
  LABS_UNI,
  OM,
  OM_V2,
  PKF,
  RAZE,
  RFUEL,
  ROYA,
  ROYA_UNI,
  TOKEN_OPTIONS,
  UNI,
} from '../../../constants/blockchain-constants';
import { CHAINS_PATHS, TOKENS_PATHS } from '../../../constants/router-constants';
import { useDispatch, useSelector } from 'react-redux';
import closeWhiteIcon from '../../../assets/images/close-icon.svg';
import ConnectWalletBackground from '../../../assets/images/connect-wallet-frame.svg';
import styles from '../card-table/card-table.module.scss';
import stylesFrame from '../card-table/frames/styles/frame/frame.module.scss';
import stylesLocal from './card-unauthorized.module.scss';
import { LOGIN_MODAL } from '../../../constants/modal-constants';
import { useGetTheme } from '../../../hooks/useGetTheme';
import ETH_ICON from '../../../assets/images/currencies/eth-logo.svg';

const CardUnauthorized = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();
  const { activeTab } = useSelector((state) => state.staking);
  const path = activeTab || window.location.pathname;

  const showLoginModal = () => {
    dispatch(modalActions.showModal(LOGIN_MODAL));
  };

  const subIcons = [colors.icons.unicorn, ETH_ICON];

  return (
    <div className={styles.container}>
      <div>
        <Tabs />
        <div className={styles.tableBody}>
          <div className={styles.wrap}>
            <ColumnTotalStakedAmountTitle />
            <ColumnStatusTitle />
            <ColumnEstimatedAprTitle />
            <ColumnEstimatedDailyRewardsTitle />
            <ColumnEarnedRewardsTitle />
          </div>
          {TOKENS_PATHS.includes(path) && (
            <>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[OM_V2].icon} token={OM} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[RFUEL].icon} token={RFUEL} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[UNI].icon} subIcons={subIcons} token='UNI OM/ETH' />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[ROYA].icon} token={ROYA} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[FXF].icon} token={FXF} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub
                  icon={TOKEN_OPTIONS[ROYA_UNI].icon}
                  subIcons={subIcons}
                  token='UNI ROYA/ETH'
                />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub
                  icon={TOKEN_OPTIONS[LABS_UNI].icon}
                  subIcons={subIcons}
                  token='UNI LABS/ETH'
                />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub
                  icon={TOKEN_OPTIONS[LABS_UNI].icon}
                  subIcons={subIcons}
                  token='UNI LABS/ETH'
                />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[L3P].icon} token={L3P} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[LABS].icon} token={LABS} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[PKF].icon} token={PKF} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[KYL].icon} token={KYL} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[RAZE].icon} token={RAZE} />
              </div>
            </>
          )}
          {CHAINS_PATHS.includes(path) && (
            <>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[DOT].icon} token={DOT} />
              </div>
              <div className={styles.balanceItemWrap}>
                <Stub icon={TOKEN_OPTIONS[KSM].icon} token={KSM} />
              </div>
            </>
          )}
        </div>
      </div>
      <div className={cn(styles.stakeSidebarContainer)}>
        <div className={styles.stakeSidebar}>
          <div className={styles.stakeSidebarHeader}>
            <button onClick={() => {}} className={styles.stakeSidebarClose}>
              <img src={closeWhiteIcon} alt='close' />
            </button>
          </div>
          <div
            className={cn(stylesFrame.cardContainer, stylesLocal.container)}
            style={{ color: colors.text, backgroundColor: colors.background }}
          >
            <img className={stylesLocal.background} src={ConnectWalletBackground} alt='' />
            <Button
              className={stylesLocal.button}
              variant='contained'
              color='secondary'
              onClick={showLoginModal}
            >
              Connect Wallet
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardUnauthorized;
